module.exports = __webpack_public_path__ + "static/media/info.6b4bb51b.svg";